/* eslint-disable require-jsdoc */
import {callLambda} from '@/lib/api/lambda';
import _ from 'lodash';

/**
 * 取得直播課程紀錄
 * @param {String} liveCourseId liveCourseId
 * @param {String} classId classId
 * @returns {Promise} promise
 */
async function getLiveCoursesRecord({liveCourseId, classId}) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'record',
    params: {
      liveCourseId,
      classId,
    },
  });
  const urls = res.data;
  if (Array.isArray(res.data)) {
    return urls[0];
  }
  return urls;
}

/**
 * 取得兒童啟蒙班直播課程
 * @returns {Promise} promise
 */
async function getKid2WeekLiveCourses() {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'kid2weekCourse',
  });
  return res.data;
}

/**
 * 取得標籤直播課程
 * @param {Object} params 篩選資料
 * @returns {Promise} promise
 */
const getLiveCoursesByTags = _.memoize(
  async function getLiveCoursesByTags(params) {
    const res = await callLambda({
      category: 'liveCourse',
      method: 'GET',
      apiName: 'getCoursesByTags',
      params,
    });
    return res.data;
  },
  (params) => JSON.stringify(params)
);

/**
 * 取得老師非官方直播課程
 * @param {Object} params 篩選資料
 * @returns {Promise} promise
 */
const getTeacherNormalLiveCourseList = _.memoize(
  async function getTeacherNormalLiveCourseList(params) {
    const {
      limit,
      isAscending,
      lastEndAt,
      lastId,
      startAt,
      endAt,
      keyword,
      subAcademyId,
      classId,
      teacherUsername,
      language = 'zh-TW',
    } = params;
    const res = await callLambda({
      category: 'backstage',
      method: 'GET',
      apiName: 'normalLiveCourse',
      params: {
        limit,
        isAscending,
        lastEndAt,
        lastId,
        startAt,
        endAt,
        keyword,
        subAcademyId,
        classId,
        teacherUsername,
        language,
      },
    });
    return res.data;
  },
  (params) => JSON.stringify(params)
);

const getStudentNormalLiveCourseList = _.memoize(
  async function getStudentNormalLiveCourseList(params) {
    const {limit, isAscending, lastEndAt, lastId, startAt, endAt, language} =
      params;
    const res = await callLambda({
      category: 'liveCourse',
      method: 'GET',
      apiName: 'student/courses',
      params: {
        limit,
        isAscending,
        lastEndAt,
        lastId,
        startAt,
        endAt,
        language,
      },
    });
    return res.data;
  },
  (params) => JSON.stringify(params)
);
/**
 * 取得標籤
 * @param {Object} params 篩選資料
 * @returns {Promise} promise
 */
async function getTags(params) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'tags',
    params,
  });
  return res.data;
}

/**
 * 取得標籤
 * @returns {Promise} promise
 */
async function getTeacherTags() {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'tags/teacher',
  });
  return res.data;
}

/**
 * 訂閱直播
 * @param {String} liveCourseId  直播課 ID
 * @param {String} coursePlan  方案 ID
 * @returns {Promise} promise
 */
async function postNotification(liveCourseId, coursePlan) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'POST',
    apiName: 'notification',
    data: {
      liveCourseId,
      coursePlan,
    },
  });
  return res.data;
}

/**
 * 取消訂閱直播
 * @param {String} liveCourseId  直播課 ID
 * @returns {Promise} promise
 */
async function deleteNotification(liveCourseId) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'DELETE',
    apiName: 'notification',
    data: {
      liveCourseId,
    },
  });
  return res.data;
}

/**
 *
 * @param {String} liveCourseId 班級id
 * @param {String} timestamp 時間
 * @returns {Promise} promise
 */
function postLiveCourseRecord(liveCourseId, timestamp) {
  return callLambda({
    category: 'liveCourse',
    method: 'POST',
    apiName: 'record',
    data: {
      liveCourseId,
      timestamp,
    },
  }).then((res) => {
    return res;
  });
}

/** getTeacherQuotaDetail
 * @returns {Promise} promise
 */
async function getTeacherQuotaDetail({username, startTime, endTime}) {
  const res = await callLambda({
    category: 'backstage',
    apiName: 'getTeacherQuotaDetail',
    method: 'get',
    params: {username, startTime, endTime},
  });
  return res.data;
}

/** getTeacherLiveCourseQuota
 * @returns {Promise} promise
 */
async function getTeacherLiveCourseQuota({username}) {
  const res = await callLambda({
    category: 'backstage',
    apiName: 'getTeacherLiveCourseQuota',
    method: 'get',
    params: {username},
  });
  return res.data;
}

export default {
  getLiveCoursesByTags,
  getTeacherNormalLiveCourseList,
  getStudentNormalLiveCourseList,
  getKid2WeekLiveCourses,
  getTags,
  getLiveCoursesRecord,
  postNotification,
  deleteNotification,
  postLiveCourseRecord,
  getTeacherTags,
  getTeacherQuotaDetail,
  getTeacherLiveCourseQuota,
};
